import { HashRouter } from 'react-router-dom';
import { ErrorBoundary } from "@appsignal/react";
import Appsignal from "@appsignal/javascript";

import ESignRouter from './router'

import 'bootstrap/dist/css/bootstrap.css';

const appsignal = new Appsignal({
  key: '758f2e7e-8216-4e3e-87ac-55aed9688521'
});

const App = () => {
  
  const handleAppSignalError = error => {
    if ( window.location.host.indexOf( 'sign.iqiglobal.com' ) > -1 ) {
      const span = appsignal.createSpan()
      let temp = error 
      temp.name = error.message
      span.setError( temp )
      span.setTags({ 
        location: window.location.href
      })
      appsignal.send( span )
    }
  } 

  return (
    <ErrorBoundary
      instance={ appsignal }
      fallback={ error => handleAppSignalError( error )}>
      <HashRouter>
        <ESignRouter />
      </HashRouter>  
    </ErrorBoundary>
  )
}

export default App;
